import styled from "styled-components/macro";

export const TableBody = styled.div`
  height: 100%;
  flex-grow: 1;
  overflow: auto;
  margin-top: 4px;
`;
